import { Component, Input } from "@angular/core";
import { symbolsForexOrder, getSymbolOrder } from "../../services/data/data.service";
import { WorkspaceServiceService } from "../../services/workspace-service.service";

@Component({
    selector: "header-boxes",
    template: require('./header-boxes.component.html'),
    styles: [require('./header-boxes.component.scss')]
})
export class HeaderBoxesComponent  {
    private _symbolsOrder: string[] = symbolsForexOrder;

    public get visibleBoxes() {
        let standardVisible = this.workspaceServiceService.data.boxes.filter(b => b.visible && b.searchVisible);        
        let type = this.workspaceServiceService.data.activeSymbolType;
        if (standardVisible.length < this.boxesLimit) {
            let notInStandardVisible = this.workspaceServiceService.data.boxes
                .filter(item=> standardVisible.indexOf(item) === -1 && item.Type == type && item.visible)
                .slice(0, this.boxesLimit - standardVisible.length);
            let merge = standardVisible.concat(notInStandardVisible);
            return merge; //.sort((a, b) => this.getSymbolOrder(a.Symbol)-this.getSymbolOrder(b.Symbol));//.slice(0, this.boxesLimit);
        } else {
            return standardVisible
                .sort((a, b) => this.getSymbolOrder(a.Symbol) - this.getSymbolOrder(b.Symbol))
                .slice(0, this.boxesLimit);
        }
    }

    private get boxesLimit() {
        return Math.max(Math.min(this._maxBoxes, this.containerWidth / this._boxWidth - 1), 0);
    }

    private _maxBoxes = 6;
    private _boxWidth = 48;
    

    @Input("containerWidth")
    public containerWidth = this._boxWidth * this._maxBoxes;

    constructor(private workspaceServiceService: WorkspaceServiceService) {}

    private getSymbolOrder(symbol: string) {
        return getSymbolOrder(symbol, this._symbolsOrder);
    }

    public setCharts(v:string)
    {
       // console.log(v);
        this.workspaceServiceService.data.globaGridMode.emitSymbolChanged({ symbol: v, overrideLockAllCharts: false });
    }

}
